import { IconPlus } from '@vtex/admin-ui'
import { DefaultProps } from 'typings'
import { styles } from './styles'

type Props = DefaultProps & {
  name: string
  onClick: () => void
}

export function AddChip(props: Props) {
  const { name, children, onClick } = props

  return (
    <div
      className={styles.addChip}
      onClick={onClick}
      data-testid={`add-chip-${name}`}
    >
      <IconPlus size="small" />
      {children}
    </div>
  )
}
